// extracted by mini-css-extract-plugin
module.exports = {"container":"FilterTags_container__FAaso","padding36":"FilterTags_padding36__PtLDE","filterTagsContainer":"FilterTags_filterTagsContainer__xHaQJ"};